import { type TierConfig, type WorkforceType } from './types';

export const TIER_CONFIGS: Record<WorkforceType, TierConfig[]> = {
  desk: [
    {
      label: 'Junior / Support',
      departurePercent: 20,
      replacementMultiplier: 0.5,
      salaryRatio: 0.58,
    },
    {
      label: 'Professional',
      departurePercent: 65,
      replacementMultiplier: 0.8,
      salaryRatio: 1.04,
    },
    {
      label: 'Senior / Manager',
      departurePercent: 15,
      replacementMultiplier: 2.0,
      salaryRatio: 1.56,
    },
  ],
  frontline: [
    {
      label: 'Frontline',
      departurePercent: 85,
      replacementMultiplier: 0.5,
      salaryRatio: 0.86,
    },
    {
      label: 'Professional',
      departurePercent: 10,
      replacementMultiplier: 0.8,
      salaryRatio: 1.36,
    },
    {
      label: 'Senior / Manager',
      departurePercent: 5,
      replacementMultiplier: 2.0,
      salaryRatio: 2.07,
    },
  ],
};

export const DEFAULT_TURNOVER: Record<WorkforceType, number> = {
  desk: 14,
  frontline: 30,
};

export const IMPROVEMENT_POINTS: Record<WorkforceType, number> = {
  desk: 1,
  frontline: 2,
};

export const GBP_TO_USD = 1.34;

export const CURRENCY_SYMBOLS: Record<string, string> = {
  gbp: '£',
  usd: '$',
};

export const MIN_SALARY: Record<string, number> = {
  gbp: 15000,
  usd: 20000,
};

export const VALIDATION = {
  employees: { min: 100, max: 500000 },
  turnover: { min: 1, max: 60 },
};
